import $ from 'bianco.query';
import { loadImages } from 'bianco.images-loader';

/**
 * Helper function that will query all the current images in the DOM returning a promise resolved when all of them will be loaded
 * @returns {Promise}
 */
export default function imagesLoaded() {
    return loadImages($('img'));
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/images-loaded.js